// What the account screens send and keep (backfill PR 32): the fields the profile form sends
// to PATCH /api/users/profile (ProfileScreen: only what changed, and the marketing preferences
// as a whole once one of them changed) and the stored login after an email verification
// (EmailVerificationScreen).
export const profileUpdates = ({
  userInfo,
  username,
  email,
  newPassword,
  marketingPreferences,
}) => {
  const {
    receiveMarketingEmails,
    newProductArrivals,
    restockAnnouncements,
    eventsAndDiscounts,
    companyNews,
  } = marketingPreferences;

  const updatedData = {};
  if (username !== userInfo.username) updatedData.username = username; // adds the username to the updated data, if the value for it has changed
  if (email.toLowerCase() !== userInfo.email) updatedData.email = email; // adds the email to the updated data, if the value for it has changed; compared in lowercase, as the account stores it, so the own address typed with a capital sends nothing (it sent a change the route answers as none, until Oct 2026)
  if (newPassword !== '') updatedData.password = newPassword; // adds the password to the updated data, if the user typed something into this field

  // check if any marketing preferences have changed:
  const mp = userInfo.marketingPreferences || {};
  const marketingPreferencesChanged =
    receiveMarketingEmails !== mp.receiveMarketingEmails ||
    newProductArrivals !== mp.newProductArrivals ||
    restockAnnouncements !== mp.restockAnnouncements ||
    eventsAndDiscounts !== mp.eventsAndDiscounts ||
    companyNews !== mp.companyNews;

  // if any marketing preferences have changed, add all of them to updatedData:
  if (marketingPreferencesChanged) {
    updatedData.marketingPreferences = {
      receiveMarketingEmails,
      newProductArrivals,
      restockAnnouncements,
      eventsAndDiscounts,
      companyNews,
    };
  }

  return updatedData;
}; // the fields the profile form sends: empty when nothing changed, and the screen then sends nothing

export const verifiedUserInfo = (userInfo, verifiedUser) => ({
  ...userInfo,
  email: verifiedUser.email,
  tempEmail: verifiedUser.tempEmail,
}); // the stored login after the signed-in user verified an email change: the address the route confirms and the pending one it reports (undefined once none is pending)
